import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LayoutComponent } from './shared/layout/layout.component';
import { AuthLayotComponent } from './authorization/auth-layout/auth-layout.component';
import { NotFoundComponent } from './shared/pages/not-found/not-found.component';
import { HomePageComponent } from './shared/pages/home-page/home-page.component';
import { SharedModule } from './shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { reducers } from 'src/core/reducer';
import { EffectsModule } from '@ngrx/effects';
import { CommonEffect } from 'src/core/common/common.effect';
import { AccountEffect } from 'src/core/account/account.effect';
import { RootEffect } from 'src/core/root/root.effect';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from './shared/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppSettingService } from 'src/core/services/app.settings';
import { CommonSandbox } from 'src/core/common/common.sandbox';
import { AuthGuard } from 'src/core/services/auth.guard';
import { AdminGuard } from 'src/core/services/admin.guard';
import { CommonService } from 'src/core/common/common.service';
import { AccountService } from 'src/core/account/account.service';
import { AccountSandbox } from 'src/core/account/account.sandbox';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MessageService } from 'src/core/services/messages.service';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { RequestInterceptor } from 'src/core/services/request.interceptor';
import { RootService } from 'src/core/root/root.service';
import { RootSandbox } from 'src/core/root/root.sandbox';
import { CategoryService } from 'src/core/categories/categories.service';
import { CategoriesSandbox } from 'src/core/categories/categories.sandbox';
import { CategoriesEffect } from 'src/core/categories/categories.effect';
import { RoleDialogComponent } from './shared/dialogs/role-dialog/role-dialog.component';

export function HttpLoaderFactory(http: HttpClient): any {
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        AppComponent,
        LayoutComponent,
        AuthLayotComponent,
        NotFoundComponent,
        HomePageComponent,
        RoleDialogComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        SharedModule,
        StoreModule.forRoot(reducers, {
            runtimeChecks: {
                strictStateImmutability: false,
                strictActionImmutability: false,
            },
        }),
        EffectsModule.forRoot([
            CommonEffect,
            AccountEffect,
            RootEffect,
            CategoriesEffect
        ]),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        // FlexLayoutModule
    ],
    providers: [
        AppSettingService,
        CommonSandbox,
        AuthGuard,
        AdminGuard,
        CommonService,
        AccountService,
        AccountSandbox,
        RootService,
        RootSandbox,
        MatSnackBar,
        MessageService,
        CategoryService,
        CategoriesSandbox,
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } },
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptor,
            multi: true
        },
        Title
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
